import React from "react";
import { Link } from "react-router-dom";
import {
  FiCheckCircle,
  FiShoppingBag,
  FiPercent,
  FiMapPin
} from "react-icons/fi";
import PremiumHero from "../components/common/PremiumHero";

const Box = ({ title, icon, children }) => (
  <div className="bg-white border rounded-2xl p-6">
    <h3 className="text-lg font-bold text-gray-900 mb-3 flex items-center gap-2">
      <span className="text-[#e11d7b]">{icon}</span> {title}
    </h3>
    <div className="text-gray-700 leading-relaxed">{children}</div>
  </div>
);

export default function Experiences() {
  return (
    <div className="bg-white">
      <PremiumHero
        title="Maxula Experiences"
        subtitle="Spa • Hammam • Beauté • Coiffure • Restaurants • Hôtels • Loisirs • Voyages"
      />

      <section className="py-14 bg-[#fff3f8]">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 space-y-8">
          <div className="bg-white border rounded-2xl p-6 leading-relaxed text-gray-700">
            <p className="font-medium text-gray-900">
              Maxula.ma est un centre de réservation et de mise en relation entre
              les clients et nos partenaires.
            </p>
            <p className="mt-4">
              Depuis <b>2013</b>, nous offrons une expérience <b>fiable</b>,{" "}
              <b>premium</b> et <b>transparente</b> à nos clients marocains et
              étrangers.
            </p>
          </div>

          <Box title="Services Maxula Experiences" icon={<FiShoppingBag />}>
            <ul className="mt-2 grid sm:grid-cols-2 gap-3 text-gray-700">
              {[
                "Spas & hammams",
                "Salons de coiffure",
                "Centres esthétiques",
                "Hôtels, cafés & restaurants",
                "Agences de voyage",
                "Lifestyle, bien-être & loisirs"
              ].map((x) => (
                <li key={x} className="flex items-start gap-2">
                  <FiCheckCircle className="text-[#e11d7b] mt-0.5" />
                  <span>{x}</span>
                </li>
              ))}
            </ul>
          </Box>

          <div className="grid md:grid-cols-3 gap-6">
            <div className="bg-white border rounded-2xl p-6 text-center">
              <div className="mx-auto w-12 h-12 rounded-full bg-pink-50 border border-pink-100 flex items-center justify-center">
                <FiShoppingBag className="text-[#e11d7b]" size={22} />
              </div>
              <h4 className="mt-3 font-bold text-gray-900">1. Choisissez</h4>
              <p className="text-sm text-gray-600 mt-1">Parcourez nos offres</p>
            </div>

            <div className="bg-white border rounded-2xl p-6 text-center">
              <div className="mx-auto w-12 h-12 rounded-full bg-pink-50 border border-pink-100 flex items-center justify-center">
                <FiPercent className="text-[#e11d7b]" size={22} />
              </div>
              <h4 className="mt-3 font-bold text-gray-900">2. Réservez</h4>
              <p className="text-sm text-gray-600 mt-1">Confirmation & coupon</p>
            </div>

            <div className="bg-white border rounded-2xl p-6 text-center">
              <div className="mx-auto w-12 h-12 rounded-full bg-pink-50 border border-pink-100 flex items-center justify-center">
                <FiMapPin className="text-[#e11d7b]" size={22} />
              </div>
              <h4 className="mt-3 font-bold text-gray-900">3. Profitez</h4>
              <p className="text-sm text-gray-600 mt-1">Chez le partenaire</p>
            </div>
          </div>

          <div className="flex justify-center">
            <Link
              to="/deals"
              className="inline-flex items-center justify-center px-6 py-3 rounded-xl bg-[#e11d7b] text-white font-semibold shadow hover:shadow-lg transition"
            >
              Explorer les deals
            </Link>
          </div>

          <div className="text-xs text-gray-500 text-center">
            Maxula agit en tant qu’intermédiaire : la prestation est réalisée par
            le partenaire.
          </div>
        </div>
      </section>
    </div>
  );
}
